<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'" type="button" (click)="chiudiModale();">Chiudi</button>
		</p>
    <div class="col-sm-12 coldx" *ngIf="html">
      <h4>Dettaglio documento</h4>
      <div [innerHTML]="titolo"></div>
      <div [innerHtml]="html"></div>
    </div>
	</div>
</div>
